<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.ec_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ec_dpname">
            <label class="weui-form-preview__label">{{customLabel.ec_dpname || "申请部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_dpname}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ec_type">
            <label class="weui-form-preview__label">{{customLabel.ec_type || "申请类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_type}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ec_reason">
            <label class="weui-form-preview__label">{{customLabel.ec_reason || "变更原因"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_reason}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ec_change_code">
            <label class="weui-form-preview__label">{{customLabel.ec_change_code || "变更单号"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_change_code}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == 'BOM变更'" slot="ec_bomcode">
            <label class="weui-form-preview__label">{{customLabel.ec_bomcode || "选择BOM"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_bomcode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == 'BOM变更'" slot="ec_prcode">
            <label class="weui-form-preview__label">{{customLabel.ec_prcode || "成品编号"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_prcode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == 'BOM变更'" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "成品名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == 'BOM变更'" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "成品型号"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == '物料变更'" slot="ec_prcode">
            <label class="weui-form-preview__label">{{customLabel.ec_prcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_prcode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == '物料变更'" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == '物料变更'" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type == '物料变更'" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type != 'BOM变更' && form.main.ec_type != '物料变更'" slot="folder_name">
            <label class="weui-form-preview__label">{{customLabel.folder_name || "文档路径"}}</label>
            <span class="weui-form-preview__value">{{form.main.folder_name}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ec_type != 'BOM变更' && form.main.ec_type != '物料变更'" slot="file_name">
            <label class="weui-form-preview__label">{{customLabel.file_name || "文件名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.file_name}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ec_remark">
            <label class="weui-form-preview__label">{{customLabel.ec_remark || "变更描述"}}</label>
            <span class="weui-form-preview__value">{{form.main.ec_remark}}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.ec_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <!-- <router-link
        :to="'/oa/ecr_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link> -->
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/plm/ecr",
      codeField: "ec_code",
      statusField: "ec_statuscode",
      caller: "Ecr",
      xtype: "plm-ecr-formpanel",
    };
  }
};
</script>